// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2Hh4q","content":"styles_content__3wOFf","selectAll":"styles_selectAll__1P8Mq"};